import * as _ from "lodash";
import * as React from "react";
import { PureComponent } from "react";
import { Route, Switch } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { FormattedMessage } from "@oursky/react-messageformat";
import * as dateFormat from 'dateformat';
import Select from 'react-select';
import CampaignContextProvider, {
  Consumer,
  CampaignContext,
} from "./context/CampaignContext";
import Offer from "./components/Offer";
import styles from "./Campaign.module.scss";
import { changeLocale } from "./redux/app";
import { email, phone, startDate, endDate } from "./config";
import { RootState } from "./redux/types";
import { BeaOffer } from "./types";

const localeOptions = [
  {value: "en", label: "EN"},
  {value: "zh-Hant-HK", label: "繁體中文"},
  {value: "zh-Hans-HK", label: "简体中文"},
];

class _Header extends PureComponent<any> {
  state = {
    selectedLocale: null,
  };

  componentDidMount() {
    const { locale } = this.props;
    const selectedLocale = localeOptions.filter((x: any) => x.value === locale);
    this.setState({
      selectedLocale,
    });
  }

  handleChange = (selectedOption: any) => {
    this.setState({
      selectedLocale: selectedOption,
    });
    this.props.changeLocale(selectedOption.value);
  };

  render() {
    const { selectedLocale } = this.state;
    return (
      <header className={styles.headerWrapper}>
        <section className={styles.header}>
          <img src="/img/logo.png" className={styles.logo}/>
          <Select
            value={selectedLocale}
            onChange={this.handleChange}
            options={localeOptions}
            className={styles.localeSelect}
            classNamePrefix="react-select"
            isSearchable={false}
          />
        </section>
      </header>
    );
  }
}

function _mapStateToProps(state: any) {
  return {
    locale: state.app.locale,
  };
}

function _mapDispatchToProps(dispatch: Dispatch) {
  return {
    changeLocale: bindActionCreators(changeLocale, dispatch),
  };
}

const Header = connect(_mapStateToProps, _mapDispatchToProps)(_Header);

class Hero extends PureComponent<any> {
  render() {
    return (
      <div className={styles.heroWrapper}>
        <div className={styles.heroImage} />
        <section className={styles.hero}>
          <p className={styles.heroMessage}>
            <FormattedMessage id="HERO.en.Message" />
          </p>
        </section>
      </div>
    );
  }
}

class Promotion1 extends PureComponent<any> {
  componentDidMount() {
    const { context } = this.props;
    context.getBeaOffers();
  }

  render() {
    const { beaOffers } = this.props.context;
    return (
      <section className={styles.promotion1}>
        <h2 className={styles.promotionHeader}>
          <span className={styles.promotionHeaderText}>
            <FormattedMessage
              id="PROMOTION.Header"
              values={{
                id: 1,
              }}
            />
          </span>
        </h2>
        <h3 className={styles.promotionTagline}>
          <FormattedMessage
            id="PROMOTION1.Tagline"
            values={{
              emphasized: <span className={styles.promotionTaglineEmphasized}>
                <FormattedMessage
                  id="PROMOTION1.TaglineEmphasized"
                />
              </span>,
            }}
          />
        </h3>
        <div className={styles.promotion1Offers}>
          {beaOffers.map((beaOffer: BeaOffer, i: number) => (
            <Offer
              key={i}
              taglineTranslation={{
                en: beaOffer.tagline["en-US"],
                "zh-Hant-HK": beaOffer.tagline["zh-TW"],
                "zh-Hans-HK": beaOffer.tagline["zh-CN"],
              }}
              imageUrl={beaOffer.image_url}
              wineNameTranslation={{
                "en": beaOffer.wine_name["en-US"],
                "zh-Hant-HK": beaOffer.wine_name["zh-TW"],
                "zh-Hans-HK": beaOffer.wine_name["zh-CN"],
              }}
              vintage={beaOffer.offer.wine.vintage}
              quantityPerCase={parseInt(beaOffer.offer.wine.packing_size.split(" x ")[0], 10)}
              marketPrice={beaOffer.offer.wine.market_price}
              price={beaOffer.offer.price}
              wine={beaOffer.offer.wine}
              offerId={beaOffer.offer.id}
              soldout={beaOffer.offer.soldout}
            />
          ))}
        </div>
      </section>
    );
  }
}

class Promotion2 extends PureComponent<any> {
  render() {
    return (
      <section className={styles.promotion2}>
        <h2 className={styles.promotionHeader}>
          <span className={styles.promotionHeaderText}>
            <FormattedMessage
              id="PROMOTION.Header"
              values={{
                id: 2,
              }}
            />
          </span>
        </h2>
        <h3 className={styles.promotionTagline}>
          <FormattedMessage
            id="PROMOTION2.Tagline"
            values={{
              emphasized: <span className={styles.promotionTaglineEmphasized}>
                <FormattedMessage
                  id="PROMOTION2.TaglineEmphasized"
                />
              </span>,
              sub: <span className={styles.promotionTaglineSub}>
                <FormattedMessage
                  id="PROMOTION2.TaglineSub"
                />
              </span>,
            }}
          />
        </h3>
        <div className={styles.promotion2Table}>
          <div className={styles.promotion2Column}>
            <img src="/img/promo-1.png" className={styles.promotion2MainImg} />
          </div>
          <div className={styles.promotion2Column}>
            <img src="/img/promo-2.png" className={styles.promotion2InterImg} />
            <p className={styles.promotionHelpText}>
              <FormattedMessage id="PROMOTION2.P1" values={{
                bold: <b>
                  <FormattedMessage id="PROMOTION2.P1.Bold" />
                </b>,
              }} />
            </p>
          </div>
        </div>
      </section>
    );
  }
}

class _TermsAndConditions extends PureComponent<any> {
  render() {
    const { locale } = this.props;
    return (
      <div className={styles.termsAndConditionsWrapper}>
        <section className={styles.termsAndConditions}>
          <h4 className={styles.termsAndConditionHeader}>
            <FormattedMessage id="TERMS_AND_CONDITIONS.Title" />
          </h4>
          <ol className={styles.termsAndConditionsList}>
            <li className={styles.termsAndConditionItem}>
              <FormattedMessage id="TERMS_AND_CONDITIONS.P1" values={{
                from: dateFormat(startDate, (() => {
                  if (locale === "zh-Hant-HK") {
                    return "dd/mm";
                  }
                  if (locale === "zh-Hans-HK") {
                    return "dd/mm";
                  }
                  return "d mmm yyyy";
                })()),
                to: dateFormat(endDate, (() => {
                  if (locale === "zh-Hant-HK") {
                    return "dd/mm/yyyy";
                  }
                  if (locale === "zh-Hans-HK") {
                    return "dd/mm/yyyy";
                  }
                  return "d mmm yyyy";
                })()),
              }} />
            </li>
            <li className={styles.termsAndConditionItem}>
              <FormattedMessage id="TERMS_AND_CONDITIONS.P2" />
            </li>
            <li className={styles.termsAndConditionItem}>
              <FormattedMessage id="TERMS_AND_CONDITIONS.P3" />
            </li>
            <li className={styles.termsAndConditionItem}>
              <FormattedMessage id="TERMS_AND_CONDITIONS.P4" />
            </li>
            <li className={styles.termsAndConditionItem}>
              <FormattedMessage id="TERMS_AND_CONDITIONS.P5" />
            </li>
            <li className={styles.termsAndConditionItem}>
              <FormattedMessage id="TERMS_AND_CONDITIONS.P6" values={{
                email: <a href={`mailto:${email}`}>{email}</a>,
                phone,
              }} />
            </li>
            <li className={styles.termsAndConditionItem}>
              <FormattedMessage id="TERMS_AND_CONDITIONS.P7" />
            </li>
          </ol>
        </section>
      </div>
    );
  }
}

const TermsAndConditions = connect((state: RootState) => {
  return {
    locale: state.app.locale,
  };
})(_TermsAndConditions);

class Home extends PureComponent<any> {
  renderWithContext = (campaignContext: CampaignContext) => {
    return (
      <>
        <Header />
        <Hero context={campaignContext}/>
        <Promotion1 context={campaignContext}/>
        <Promotion2 />
        <TermsAndConditions />
      </>
    );
  }

  render() {
    return (
      <CampaignContextProvider>
      	<Consumer>{this.renderWithContext}</Consumer>
      </CampaignContextProvider>
    );
  }
}

class Campaign extends React.Component<any> {
  render() {
    return (
      <Switch>
        <Route exact={true} path="/" component={Home} />
      </Switch>
    );
  }
}

export default Campaign;



// WEBPACK FOOTER //
// ./src/Campaign.tsx